import React, { useEffect } from 'react';
import './TermsNconditions.css';
import '../PolicyPages.css';

function TermsNconditions() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="policy-page">

            {/* Hero */}
            <div className="policy-hero">
                <div className="container">
                    <div className="policy-hero-icon"><i className="fas fa-file-alt"></i></div>
                    <h1 className="policy-hero-title">Terms &amp; Conditions</h1>
                    <p className="policy-hero-sub">Last updated: June 2025</p>
                </div>
            </div>

            {/* Card */}
            <div className="container">
                <div className="policy-card">

                    <p className="policy-intro">
                        Welcome to <strong>PENTADECO</strong>. These Terms and Conditions govern your use of our website,{' '}
                        <a href="https://pentadeco.in" target="_blank" rel="noreferrer">www.pentadeco.in</a>,
                        and the purchase of any products from our online store. By accessing or using our website,
                        you agree to comply with and be bound by these Terms and Conditions.
                    </p>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">1</span>
                            <h3 className="policy-section-title">General Information</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>About Us:</strong> PENTADECO is an Indian e-commerce platform offering home décor, kitchen décor, and personal accessories.</li>
                            <li><strong>Acceptance:</strong> These Terms govern all aspects of your relationship with the Website, including browsing, purchasing, payments, shipping, returns, and customer service.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">2</span>
                            <h3 className="policy-section-title">Eligibility to Use</h3>
                        </div>
                        <p className="policy-text">
                            You must be at least 18 years old or have the involvement of a parent/guardian to make purchases.
                            By using this site, you confirm you can legally enter into a binding contract under the Indian Contract Act, 1872.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">3</span>
                            <h3 className="policy-section-title">Account Responsibilities</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Account Creation:</strong> You may need to create an account to purchase. Keep login details secure.</li>
                            <li><strong>Accuracy:</strong> You must provide true and updated information.</li>
                            <li><strong>Responsibility:</strong> All activities done under your account are your responsibility.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">4</span>
                            <h3 className="policy-section-title">Products &amp; Services</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Accuracy:</strong> We strive to provide correct descriptions, images, and prices. Minor variations may occur due to photography or screen resolution.</li>
                            <li><strong>Availability:</strong> Products are subject to stock. Orders may be cancelled if unavailable.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">5</span>
                            <h3 className="policy-section-title">Orders &amp; Payment</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Confirmation:</strong> Orders are confirmed only after receiving an order confirmation email/SMS.</li>
                            <li><strong>Payment Methods:</strong> We accept UPI, Net Banking, Cards, Wallets, and COD (select areas).</li>
                            <li><strong>Currency:</strong> All transactions are in INR.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">6</span>
                            <h3 className="policy-section-title">Shipping &amp; Delivery</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Timeline:</strong> Orders typically deliver within 3–7 working days.</li>
                            <li><strong>Courier Partner:</strong> Once dispatched, delivery is handled by our courier partner.</li>
                            <li><strong>Tracking:</strong> Details are shared post-dispatch.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">7</span>
                            <h3 className="policy-section-title">Returns &amp; Refunds</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Return:</strong> Returns are accepted within 7 days for defective, damaged, or incorrect items.</li>
                            <li><strong>Refunds:</strong> Processed within 7–10 working days to original payment method.</li>
                            <li><strong>Exclusions:</strong> Personalized products, clearance items, or misuse-related damage not eligible.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">8</span>
                            <h3 className="policy-section-title">Intellectual Property</h3>
                        </div>
                        <p className="policy-text">
                            All content (text, logos, images, designs, product info) on this site is owned by PENTADECO.
                            You cannot copy, modify, or use it without written consent.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">9</span>
                            <h3 className="policy-section-title">User Restrictions</h3>
                        </div>
                        <p className="policy-text">
                            You agree not to: misuse this Website, upload viruses, hack our systems, or resell products without permission.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">10</span>
                            <h3 className="policy-section-title">Limitation of Liability</h3>
                        </div>
                        <p className="policy-text">
                            Our liability is limited to the value of your purchased product. We are not responsible for indirect,
                            incidental, or consequential damages.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">11</span>
                            <h3 className="policy-section-title">Termination</h3>
                        </div>
                        <p className="policy-text">
                            We reserve the right to suspend or terminate accounts for violations of these Terms.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">12</span>
                            <h3 className="policy-section-title">Governing Law</h3>
                        </div>
                        <p className="policy-text">
                            These Terms are governed by the laws of India. All disputes fall under the jurisdiction of New Delhi courts.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">13</span>
                            <h3 className="policy-section-title">Changes to Terms</h3>
                        </div>
                        <p className="policy-text">
                            We may update these Terms at any time. Continued use means acceptance of the updated Terms.
                        </p>
                    </div>

                    {/* Contact */}
                    <div className="policy-contact-card">
                        <p className="policy-contact-title"><i className="fas fa-headset"></i> Contact Us</p>
                        <div className="policy-contact-row">
                            <i className="fas fa-building"></i>
                            <span>PENTADECO Customer Service</span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fas fa-envelope"></i>
                            <span><a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a></span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fab fa-whatsapp"></i>
                            <span>
                                <a href="tel:+917738494171">+91 77384 94171</a> &nbsp;|&nbsp;
                                <a href="tel:+918433551012">+91 84335 51012</a> &nbsp;|&nbsp;
                                <a href="tel:+919273158535">+91 92731 58535</a>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default TermsNconditions;
